import type { ApiParams } from './types';
import { API_URL } from '@Constants';
import { useGlobalAbortController } from '@Composables';
import { axios } from '@Libraries';

const DEFAULT_AXIOS_OPTIONS = {
  validateStatus: (status: number) => status >= 200 && status < 300,
};

export default async function (params: ApiParams) {
  const { endpoint, method, payload, isUpload } = params;
  const apiEndpoint = endpoint.replace('/api', API_URL);

  const { getCurrentController } = useGlobalAbortController();
  const currentController = getCurrentController();

  const axiosOptions = {
    ...DEFAULT_AXIOS_OPTIONS,
    method,
    data: payload,
    signal: currentController?.signal,
    headers: { 'Content-Type': isUpload ? 'multipart/form-data' : 'application/json' },
  };

  return axios(apiEndpoint, { ...axiosOptions }).then((response) => response?.data ?? new Promise(() => {}));
}
